import type { RouteRecordRaw } from 'vue-router';

export const ORDER_ROUTER: RouteRecordRaw[] = [
  {
    path: '/order',
    component: () => import('@/components/layout/Default.vue'),
    meta: { requiresAuth: true },
    redirect: '/order/list',
    children: [
      {
        path: 'list',
        component: () => import('@/modules/order/orderMaster/views/OrderList.vue'),
        name: 'Order List',
        meta: {
          title: '발주 목록',
        },
      },
      {
        path: 'create',
        component: () => import('@/modules/order/orderMaster/views/OrderCreate.vue'),
        name: 'Order Create',
        meta: {
          title: '발주 등록',
        },
      },
    ],
  },
];
